
/**
 * Enforces light theme in the cloned document
 */
export const enforceLightThemeInDocument = (clonedDoc: Document): void => {
  // Remove dark mode class from document root
  const htmlElement = clonedDoc.documentElement;
  htmlElement.classList.remove('dark');
  htmlElement.classList.add('light');
  
  // Update CSS variables to light theme values
  htmlElement.style.setProperty('--quote-bubble-color', '#f3f4f6');
  
  // Force light theme on any elements with dark-specific styling
  const darkElements = clonedDoc.querySelectorAll('[class*="dark:"]');
  darkElements.forEach(el => {
    if (el instanceof HTMLElement) {
      // Get computed styles
      const computedStyle = window.getComputedStyle(el);
      
      // Force background to white/light for dark elements
      if (computedStyle.backgroundColor && computedStyle.backgroundColor !== 'rgba(0, 0, 0, 0)') {
        if (computedStyle.backgroundColor.includes('rgb(0, 0, 0)') || 
            computedStyle.backgroundColor.includes('rgb(17, 24, 39)') ||
            computedStyle.backgroundColor.includes('rgba(0, 0, 0,')) {
          el.style.backgroundColor = 'white';
        }
      }
      
      // Force text to dark for readability
      if (computedStyle.color && 
          (computedStyle.color.includes('rgb(255, 255, 255)') || 
           computedStyle.color.includes('rgba(255, 255, 255,'))) {
        el.style.color = '#111827';
      }
    }
  });
  
  // Ensure consistent styling for user profile card
  const profileCards = clonedDoc.querySelectorAll('.card');
  profileCards.forEach(card => {
    if (card instanceof HTMLElement) {
      card.style.backgroundColor = 'white';
      card.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
    }
  });
  
  // Force card backgrounds to white
  const cards = clonedDoc.querySelectorAll('.bg-card');
  cards.forEach(card => {
    if (card instanceof HTMLElement) {
      card.style.backgroundColor = 'white';
    }
  });
  
  // Fix journey content container with black background
  const journeyContentContainer = clonedDoc.querySelector('.bg-white.dark\\:bg-gray-800, .relative.bg-white.dark\\:bg-gray-800');
  if (journeyContentContainer instanceof HTMLElement) {
    journeyContentContainer.style.backgroundColor = 'white';
  }
  
  // Additionally target the main content area that might have a dark background
  const mainContent = clonedDoc.querySelector('main.bg-secondary\\/30.dark\\:bg-background\\/30');
  if (mainContent instanceof HTMLElement) {
    mainContent.style.backgroundColor = 'white';
  }
  
  // Apply consistent typography across components
  const allText = clonedDoc.querySelectorAll('h1, h2, h3, p, div, span');
  allText.forEach(el => {
    if (el instanceof HTMLElement) {
      el.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
    }
  });
  
  // Make italic placeholder text normal for better readability in exports
  const italicText = clonedDoc.querySelectorAll('.italic');
  italicText.forEach(el => {
    if (el instanceof HTMLElement) {
      el.style.fontStyle = 'normal';
    }
  });
}
